import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const companyLogos = [
  {
    src: '/munters-blue.png',
    name: 'Munters',
    alt: 'Munters - Líder global en control climático'
  },
  {
    src: '/6503bc603ae81612c67e8c7d_piasa-logo_(1).svg',
    name: 'PIASA',
    alt: 'PIASA - Productos Industriales'
  },
  {
    src: '/cropped-bt-logo-int-3-2.png',
    name: 'BT',
    alt: 'BT - Soluciones empresariales'
  },
  {
    src: '/anclas_virso_logo.png',
    name: 'Anclas Virso',
    alt: 'Anclas Virso - Manufactura industrial'
  },
  {
    src: '/logo_aexsa_sin_fondo.png',
    name: 'AEXSA',
    alt: 'AEXSA - Manufactura y distribución'
  }
];

const TrustedCompanies = () => {
  const { language } = useLanguage();

  return (
    <section className="py-12 md:py-16 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
            {language === 'en'
              ? 'Trusted by Leading Companies'
              : 'Confiado por Empresas Líderes'
            }
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            {language === 'en'
              ? 'Join hundreds of companies that have already transformed their operations with LAIMU'
              : 'Únete a cientos de empresas que ya han transformado sus operaciones con LAIMU'
            }
          </p>
        </div>

        <div className="relative">
          {/* Gradient fade edges */}
          <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-gray-50 to-transparent z-10 pointer-events-none"></div>
          <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-gray-50 to-transparent z-10 pointer-events-none"></div>

          {/* Logos container with animation */}
          <div className="overflow-hidden">
            <div className="flex items-center justify-center flex-wrap gap-8 md:gap-12 lg:gap-16 py-8">
              {companyLogos.map((logo, index) => (
                <div
                  key={index}
                  className="flex-shrink-0 group"
                  style={{
                    animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both`
                  }}
                >
                  <img
                    src={logo.src}
                    alt={language === 'en'
                      ? `${logo.name} - Company using LAIMU ERP system`
                      : `${logo.name} - Empresa usando sistema ERP LAIMU`
                    }
                    title={logo.alt}
                    className="h-12 md:h-16 object-contain grayscale opacity-60 hover:opacity-100 hover:grayscale-0 transition-all duration-500 group-hover:scale-110"
                    loading="lazy"
                    style={{
                      maxWidth: '180px',
                      filter: 'brightness(0) saturate(100%)'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.filter = 'none';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.filter = 'brightness(0) saturate(100%)';
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Trust indicators */}
        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold mb-2" style={{ color: '#115d7b' }}>
              500+
            </div>
            <div className="text-sm text-gray-600">
              {language === 'en' ? 'Active Companies' : 'Empresas Activas'}
            </div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold mb-2" style={{ color: '#ff8c00' }}>
              98%
            </div>
            <div className="text-sm text-gray-600">
              {language === 'en' ? 'Satisfaction Rate' : 'Tasa de Satisfacción'}
            </div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold mb-2" style={{ color: '#10b981' }}>
              $50M+
            </div>
            <div className="text-sm text-gray-600">
              {language === 'en' ? 'Cost Savings' : 'Ahorros Generados'}
            </div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold mb-2" style={{ color: '#8b5cf6' }}>
              24/7
            </div>
            <div className="text-sm text-gray-600">
              {language === 'en' ? 'Support Available' : 'Soporte Disponible'}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
};

export default TrustedCompanies;
